export default __webpack_public_path__ + "static/media/dice.903e0ad5.svg";